import styles from './LibraryDetail.css'
import {
  clearAmountField,
  submitFormCreate,
  submitFormUpdate
} from 'actions/ingredients/library'
import {connect} from 'react-redux'
import {getFormValues} from 'redux-form'
import LibraryForm from './LibraryForm'

class LibraryDetail extends React.Component {
  render () {
    return (<div className={styles.wrapper}>
      <div className={styles.form}>
        <LibraryForm
          onSubmit={this._onSubmit}
          onChangeSwitch={this._onChangeSwitch}
        />
      </div>
    </div>)
  }

  _onChangeSwitch = () => {
    this.props.dispatch(clearAmountField())
  }

  _onSubmit = (values) => {
    const {dispatch, libraries, summary, search: {outletIds}} = this.props
    let formatValues = this._formatOnSave(values)
    // we must delete the 'action' property so it doesn't sent to server.
    let allOutlet = values.action !== 'save'
    delete values.action
    // if it is create, the api wants 'remote_image_url' to be sent
    if (!values.id) {
      if (values.image && values.image.url) {
        values.remote_image_url = values.image.url
      } else {
        values.remote_image_url = ''
      }
    }
    if (values.id) {
      dispatch(submitFormUpdate(values.id, {library: formatValues}, allOutlet, libraries))
    } else {
      dispatch(submitFormCreate({library: formatValues}, allOutlet, libraries, outletIds[0], summary))
    }
  }

  _formatOnSave = (values) => {
    let {units, categories} = this.props
    let {
      id,
      name,
      image,
      in_stock,
      alert,
      stock_alert,
      cogs,
      track_cogs,
      unit_cost,
      time_synchronized,
      is_recipe,
      category_name,
      description,
      business_id,
      outlet_id} = values
    let ingredientCategoryId = values.ingredient_category_id
    let unitId = values.unit_id
    let idUncategorized = categories.find(category => category.name === 'Uncategorized').id
    // don't send in stock since it will overwrite the values
    let result = {
      'ingredient': {
        'id': id,
        'ingredient_category_id': ingredientCategoryId > 0 ? ingredientCategoryId : idUncategorized,
        'ingredient_category_name': categories.find(category => category.id === ingredientCategoryId).name,
        'name': name,
        'image': image.url === '' || image.url === null ? 'https://placehold.it/100&text=%20' : image.url,
        'unit_id': unitId,
        'remove_image': values.image.url === '',
        'remote_image_url': image.url,
        'unit_name': unitId ? units.find(unit => unit.id === unitId).name : '',
        'in_stock': in_stock,
        'alert': alert,
        'stock_alert': stock_alert,
        'cogs': values.track_cogs ? cogs : null,
        'track_cogs': track_cogs,
        'unit_cost': unit_cost,
        'time_synchronized': time_synchronized,
        'is_recipe': is_recipe,
        'category_name': category_name,
        'description': description,
        'business_id': business_id,
        'outlet_id': outlet_id
      }
    }
    if (!id) { // create
      delete result.remote_image_url
    } else { // update
      delete result.ingredient.in_stock
    }
    return result
  }
}

function mapStateToProps (state) {
  const {libraries, libraryDetail, units, categories, summary} = state.ingredients.library
  const {business} = state.moka.user
  return {
    libraries,
    libraryDetail,
    search: getFormValues('search')(state),
    units,
    categories,
    summary,
    business_id: business.id
  }
}

LibraryDetail.propTypes = {
  Library: React.PropTypes.object,
  dispatch: React.PropTypes.func
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(LibraryDetail)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Library/LibraryDetail/LibraryDetail.js